const signatureProfiles = {
  username: {
    key: 'username',
    label: 'username',
    type: 'text',
    sortable: 'custom',
  },
  email: {
    key: 'email',
    label: 'email',
    type: 'text',
    sortable: 'custom',
  },
  certificateExpiration: {
    key: 'certificateExpiration',
    label: 'certificateExpiration',
    type: 'date',
    sortable: false,
  },
  activatedAt: {
    key: 'activatedAt',
    label: 'activatedAt',
    type: 'date',
    sortable: false,
  },
  displayTitle: {
    key: 'displayTitle',
    label: 'displayTitle',
    type: 'text',
    sortable: false,
  },
  enabled: {
    label: 'enabled',
    type: 'boolean',
    sortable: false,
    align: 'center',
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 100,
    buttons: [
      {
        name: 'updateCredentials',
        icon: 'fas fa-file-signature',
      },
    ],
  },
};

export default signatureProfiles;
